<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    role="group"
    class='agpr-block'
    [ngClass]="{
        'agpr-block--cannot-move': !block.canMove,
        'agpr-block--editing': editing
    }"
    [attr.aria-label]="'Pagebuilder.block.label' | localize: { index: +blockPosition + 1, type: block.type?.label }"
    [attr.aria-describedby]="id + '_errors'"
    tabindex="0"
    (click)="onAction('edit')"
>
    @if (block.actionable) {
        @if (isInLayoutBlock || isInCuratorBlock) {
            @if (showMoveButtons && block.canMove) {
                <agpr-kebab-menu
                    #moveContextMenu
                    class="agpr-block-contextMenu agpr-block-contextMenu--topLeft agpr-block-inLayoutBlockMoveOptionsButton"
                    [id]="id + '_move'"
                    [style]="buttonTypes.iconFilled"
                    icon="fa-regular fa-arrows-up-down-left-right"
                    [panelPositionX]="panelPositions.left"
                    [options]="inLayoutBlockMovingOptions"
                    [showIcon]="true"
                    [loading]="null"
                    tooltip="PageBuilder.blockIcon.move"
                    tooltipPosition="top"
                    (panelShown)="onMenuOpened()"
                ></agpr-kebab-menu>
            }
            <agpr-kebab-menu
                class="agpr-block-contextMenu agpr-block-contextMenu--topRight agpr-block-moreOptionsButton"
                [id]="id + '_moreOptions'"
                [style]="buttonTypes.iconFilled"
                [panelPositionX]="panelPositions.right"
                [options]="editingOptions"
                [showIcon]="true"
                [loading]="null"
                tooltip="PageBuilder.blockIcon.moreOptions"
                tooltipPosition="top"
                (panelShown)="onMenuOpened()"
            ></agpr-kebab-menu>
        } @else {
            @if (showMoveButtons && block.canMove) {
                <agpr-kebab-menu
                    #moveContextMenu
                    class="agpr-block-contextMenu agpr-block-contextMenu--topLeft agpr-block-contextMenu--topLeft--outside"
                    [id]="id + '_move'"
                    [style]="buttonTypes.iconFilled"
                    icon="fa-regular fa-arrows-up-down-left-right"
                    [panelPositionX]="panelPositions.left"
                    [disabled]="!block.canMoveUp && !block.canMoveDown"
                    [options]="movingOptions"
                    [showIcon]="true"
                    [loading]="null"
                    tooltip="PageBuilder.blockIcon.move"
                    tooltipPosition="top"
                    (panelShown)="onMenuOpened()"
                ></agpr-kebab-menu>
            }

            <ul
                role="menu"
                class="agpr-block-contextMenu agpr-block-contextMenu--topRight--outside"
                [attr.aria-label]="'PageBuilder.blockMenu.edit' | localize"
            >
                @if (block.canEdit) {
                    <li role="menuitem">
                        <agpr-button
                            class="agpr-block-contextButton"
                            [id]="id + '_edit'"
                            [style]="buttonTypes.iconFilled"
                            icon="fa-regular fa-pen"
                            tooltip="PageBuilder.briefings.blockIcon.edit"
                            tooltipPosition="top"
                            (click)="onAction('edit')"
                        ></agpr-button>
                    </li>
                }
                @if (block.canAddOrRemove) {
                    <li role="menuitem">
                        <agpr-button
                            class="agpr-block-contextButton"
                            [id]="id + '_delete'"
                            [style]="buttonTypes.iconFilled"
                            icon="fa-regular fa-trash-can"
                            tooltip="PageBuilder.briefings.blockIcon.delete"
                            tooltipPosition="top"
                            (click)="onAction('delete')"
                        ></agpr-button>
                    </li>
                }
            </ul>

            <ul
                #addToTop
                role="menu"
                class="agpr-block-contextMenu agpr-block-contextMenu--center-top"
                [ngClass]="{ 'agpr-block-contextMenu--hidden': addBottomExpanded }"
                [attr.aria-label]="'PageBuilder.blockMenu.add' | localize"
                (mouseleave)="leaveContextMenu(addToTop, $event, true)"
            >
                <li role="menuitem">
                    <agpr-button
                        class="agpr-block-contextButton agpr-block-contextButton--topLeft agpr-block-contextButton--topRight agpr-inline-addTop-button"
                        [id]="id + '_addTop'"
                        [style]="buttonTypes.iconFilled"
                        icon="fa-regular fa-plus"
                        tooltip="PageBuilder.briefings.blockIcon.addBlock"
                        tooltipPosition="top"
                        ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toTop"
                        [expanded]="addTopExpanded"
                        (click)="inlineAddToggle($event)"
                    ></agpr-button>
                    <div
                        class="agpr-block-contextMenu-adderContainer"
                        (focusout)="leaveContextMenu(addToTop, $event)"
                    >
                        <div class="agpr-block-contextMenu-adder">
                            <label class="agpr-block-contextMenu-adder-header">{{ 'PageBuilder.inlineAdder.components' | localize | uppercase }}</label>
                            <agpr-block-adder
                                [id]="id + '_above_' + blockAdderId"
                                [addAtPosition]="blockPosition"
                            ></agpr-block-adder>
                            @if (areLayoutBlocksAllowed) {
                                <label class="agpr-block-contextMenu-adder-header agpr-block-contextMenu-adder-header-layout">{{ 'PageBuilder.inlineAdder.layouts' | localize | uppercase }}</label>
                                <agpr-layout-block-adder
                                    [id]="id + '_above_' + blockAdderId + '_layout'"
                                    [addAtPosition]="blockPosition"
                                    [isInline]="true"
                                ></agpr-layout-block-adder>
                            }
                        </div>
                    </div>
                </li>
            </ul>
            @if (showMoveButtons && block.canMove) {
                <ul
                    #addToBottom
                    role="menu"
                    class="agpr-block-contextMenu agpr-block-contextMenu--center-bottom"
                    [ngClass]="{'agpr-block-contextMenu--hidden': addTopExpanded}"
                    [attr.aria-label]="'PageBuilder.blockMenu.add' | localize"
                    (mouseleave)="leaveContextMenu(addToBottom, $event, true)"
                >
                    <li role="menuitem">
                        <agpr-button
                            [id]="id + '_addBottom'"
                            class="agpr-block-contextButton agpr-block-contextButton--bottomLeft agpr-block-contextButton--bottomRight"
                            icon="fa-regular fa-plus"
                            tooltip="PageBuilder.briefings.blockIcon.addBlock"
                            tooltipPosition="bottom"
                            ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toBottom"
                            [expanded]="addBottomExpanded"
                            (click)="inlineAddToggle($event)"
                            [style]="buttonTypes.iconFilled"
                        >
                        </agpr-button>
                        <div class="agpr-block-contextMenu-adderContainer">
                            <div
                                class="agpr-block-contextMenu-adder"
                                (focusout)="leaveContextMenu(addToBottom, $event)"
                            >
                                <label class="agpr-block-contextMenu-adder-header">{{ 'PageBuilder.inlineAdder.components' | localize | uppercase }}</label>
                                <agpr-block-adder
                                    [id]="id + '_below_' + blockAdderId"
                                    [addAtPosition]="blockPositionBottom"
                                ></agpr-block-adder>
                                @if (areLayoutBlocksAllowed) {
                                    <label class="agpr-block-contextMenu-adder-header agpr-block-contextMenu-adder-header-layout">{{ 'PageBuilder.inlineAdder.layouts' | localize | uppercase }}</label>
                                    <agpr-layout-block-adder
                                        [id]="id + '_below_' + blockAdderId + '_layout'"
                                        [addAtPosition]="blockPositionBottom"
                                        [isInline]="true"
                                    ></agpr-layout-block-adder>
                                }
                            </div>
                        </div>
                    </li>
                </ul>
            }
        }
    }

    <div
        class="agpr-block-content"
        [id]="id"
    >
        <div
            *ngIf="!renderable"
            class='agpr-block-placeholder'
        >
            <span class="fa agpr-block-placeholderIcon {{ block.type.icon }}" aria-hidden="true"></span>
            <span class="agpr-block-placeholderLabel">{{ block.type.label | localize }}</span>
        </div>
        <div
            *ngIf="renderable"
            class='agpr-alertMentions-rendered'
        >
            <!-- @TODO remove table and allow dynamic block to render template in NEP-3409 -->
            @if (block.displayElement.title && block.displayElement.styles.showSectionHeading) {
                <table class="agpr-alertMentions-titleContainer">
                    <tr>
                        <td *ngIf="twigData">
                            <h2
                                class="agpr-alertMentions-title"
                                [style.fontFamily]="twigData?.styles?.sectionHeading?.fontFamily"
                                [style.color]="twigData?.styles?.sectionHeading?.color"
                                [style.fontSize]="twigData?.styles?.sectionHeading?.fontSize"
                                [style.textAlign]="twigData?.styles?.sectionHeading?.alignment"
                                [style.fontWeight]="twigData?.styles?.sectionHeading?.bold ? 'bold' : 'normal'"
                                [style.fontStyle]="twigData?.styles?.sectionHeading?.italics ? 'italic' : 'normal'"
                                [style.textDecoration]="twigData?.styles?.sectionHeading?.underlined ? 'underline' : 'none'"
                            >
                                {{ block.displayElement.title }}
                            </h2>
                        </td>
                    </tr>
                </table>
            }
            <!-- @TODO allow dynamic block to render template in NEP-3409 -->
            <!-- <agpr-twig
                *ngIf="renderable"
                class="agpr-block-rendered"
                [twigTemplate]="block.type.twig"
                [data]="twigData"
            >
            </agpr-twig> -->
            <agpr-message
                [severity]="messageSeverityEnum.info"
            >
                {{ 'Alerts.mentionList.warning' | localize }}
            </agpr-message>
            <div
                class="agpr-alertMentions-mentionsStub"
            >
                <ng-container *ngTemplateOutlet="mentionSVG"></ng-container>
            </div>
        </div>
        <div class="agpr-block-overlay"></div>
    </div>
    <div
        class="agpr-block-hoverBorder"
    >
    </div>

</div>
<ng-template #mentionSVG>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 630.75 78.89" class="agpr-alertMentions-mentionsStubImage">
        <defs>
            <style>
                .cls-1 {
                    fill: #fff;
                }

                .cls-2 {
                    fill: #e5e5e5;
                }
            </style>
        </defs>
        <title>mention-22</title>
        <g id="Non_Editable_Symbol_Art" data-name="Non Editable Symbol Art">
            <rect class="cls-1" width="630.75" height="78.89" rx="2" />
            <rect class="cls-2" x="10" y="10" width="16.95" height="16.95" rx="2" />
            <rect class="cls-2" x="40.01" y="15.02" width="530.32" height="6.91" rx="2" />
            <rect class="cls-2" x="10" y="29.78" width="94.89" height="6.91" rx="2" />
            <rect class="cls-2" x="10" y="39.94" width="153.68" height="6.91" rx="2" />
            <rect class="cls-2" x="10" y="52.01" width="168.29" height="6.91" rx="2" />
            <rect class="cls-2" x="183.29" y="52.01" width="102.93" height="6.91" rx="2" />
            <rect class="cls-2" x="291.22" y="52.01" width="102.93" height="6.91" rx="2" />
            <rect class="cls-2" x="399.26" y="52.01" width="221.49" height="6.91" rx="2" />
            <rect class="cls-2" x="10" y="61.97" width="249.6" height="6.91" rx="2" />
            <rect class="cls-2" x="264.25" y="61.97" width="176.93" height="6.91" rx="2" />
            <rect class="cls-2" x="446.29" y="61.97" width="148.75" height="6.91" rx="2" />
            <rect class="cls-2" x="269.55" y="29.78" width="129.71" height="6.91" rx="2" />
            <rect class="cls-2" x="232.01" y="39.94" width="167.25" height="6.91" rx="2" />
            <rect class="cls-2" x="461.56" y="29.78" width="159.19" height="6.91" rx="2" />
            <rect class="cls-2" x="453.17" y="39.94" width="167.58" height="6.91" rx="2" />
        </g>
    </svg>
</ng-template>
<div *ngIf="block.errors?.length > 0" class="agpr-blockError">
    <agpr-form-message
        *ngFor="let error of block.errors"
    >
        {{ error | localize }}
    </agpr-form-message>
</div>
